/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationTokenModel } from '../../models/validation-token-model';

export interface GetValidationTokens$Plain$Params {
  token: string;
}

export function getValidationTokens$Plain(http: HttpClient, rootUrl: string, params: GetValidationTokens$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationTokenModel>>> {
  const rb = new RequestBuilder(rootUrl, getValidationTokens$Plain.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationTokenModel>>;
    })
  );
}

getValidationTokens$Plain.PATH = '/api/ValidationToken';
